import LinhaDre from "./LinhaDre";

import { Skeleton } from "@/components/ui/skeleton";


export default function TabelaDre({ linhas, regime, loading }) {
  return (
    <div className="rounded-2xl border bg-card overflow-hidden">
      <div className="px-4 py-3 border-b flex items-center justify-between">
        <h2 className="font-semibold">Demonstração do Resultado</h2>
        <span className="text-xs text-muted-foreground">
          {regime === "competencia" ? "Competência" : "Caixa"}
        </span>
      </div>

      {loading ? (
        <div className="p-4 space-y-2">
          {Array.from({ length: 9 }).map((_, i) => (
            <Skeleton key={i} className="h-8 rounded" />
          ))}
        </div>
      ) : linhas?.length ? (
        <div className="divide-y divide-border/40">
          {linhas.map((l, i) => (
            <LinhaDre key={`${l.rotulo}-${i}`} linha={l} />
          ))}
        </div>
      ) : (
        <p className="p-8 text-center text-sm text-muted-foreground">
          Nenhum movimento no período.
        </p>
      )}
    </div>
  );
}
